module.exports = __webpack_public_path__ + "static/img/伙伴客户-重庆医科大附一.22dfe511.png";